import { Box, CircularProgress, Modal, TextField } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { MdOutlineCancel, MdOutlineCheck } from "react-icons/md";
import { RxCross1 } from "react-icons/rx";

import { setApprovalSfa } from "../../../services/sfaApi";
import { useState } from "react";
import ErrorPopup from "../../common/particles.jsx/ErrorPopup";
import ModalConfirmationAction from "../../common/particles.jsx/ModalConfirmationAction";
import { setApprovalPbf } from "../../../services/approvalApi";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalApprovalPbf = ({
  open,
  setOpen,
  selectedRequest,
  onSuccessFunc,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [reason, setReason] = useState("");

  const handleClose = () => {
    setOpen(false);
  };

  const {
    data,
    mutate: mutateChangeStatus,
    isLoading: isLoadingChangeStatus,
  } = useMutation({
    mutationFn: setApprovalPbf,
    onSuccess: () => {
      setOpenConfirmation(true);
    },
    onError: (err) => {
      setErrorMessage(err.message.id ? err.message.id : err.message);
    },
  });

  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            maxWidth: "75%",
            overflowY: "auto",
            overflowX: "wrap",
            maxHeight: "50vh",
            padding: 0,
          }}
          className="text-left text-[12px] w-3/4 lg:w-1/3"
        >
          <div className="flex justify-between items-center px-8 py-4">
            <div className="flex gap-2 items-center flex-row">
              <div
                className={`w-12 h-12 p-1 rounded-full ${
                  selectedRequest.action === 1 ? "bg-blue-100" : "bg-red-100"
                }`}
              >
                <div
                  className={`w-full h-full p-2 rounded-full ${
                    selectedRequest.action === 1 ? "bg-blue-300" : "bg-red-300"
                  }`}
                >
                  {selectedRequest.action === 1 ? (
                    <MdOutlineCheck className="w-full h-full text-blue-500" />
                  ) : (
                    <MdOutlineCancel className="w-full h-full text-red-600" />
                  )}
                </div>
              </div>
              <p className="font-bold text-[18px] whitespace-nowrap">
                {selectedRequest.action === 1 ? "Terima" : "Tolak"} Request
              </p>
            </div>
            <RxCross1
              className="cursor-pointer hover:text-red-500"
              onClick={handleClose}
            />
          </div>

          <div className="px-8 mb-4">
            <p>
              Apakah anda yakin{" "}
              {selectedRequest.action === 1 ? "menerima" : "menolak"} pesanan
              dengan nomor invoice{" "}
              <span className="inline-block text-nowrap font-bold">
                {selectedRequest.invNum.join(", ")}?
              </span>
            </p>

            {selectedRequest.action === 2 ? (
              <TextField
                fullWidth
                multiline
                rows={3}
                placeholder="Alasan penolakan pesanan"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                sx={{ marginTop: 2 }}
              />
            ) : null}
          </div>

          <div className="px-8 mb-4 flex gap-2 items-center">
            <button
              type="button"
              className="w-full p-2 rounded-md border-2 hover:bg-gray-300 disabled:bg-gray-300 "
              disabled={isLoadingChangeStatus}
              onClick={handleClose}
            >
              Batal
            </button>
            <button
              type="button"
              disabled={
                isLoadingChangeStatus ||
                (selectedRequest.action === 2 && !reason)
              }
              className={`w-full p-2 rounded-md border-2 text-white disabled:bg-gray-300 hover:bg-gray-300 hover:border-gray-300 ${
                selectedRequest.action === 1
                  ? "border-blue-500 bg-blue-500"
                  : "border-red-500 bg-red-500"
              }`}
              onClick={() => {
                mutateChangeStatus({
                  invoice_uids: selectedRequest.uid,
                  action: selectedRequest.action === 1 ? "approve" : "reject",
                  reason: reason,
                });
              }}
            >
              {isLoadingChangeStatus ? (
                <CircularProgress size={20} />
              ) : selectedRequest.action === 1 ? (
                "Terima"
              ) : (
                "Tolak"
              )}
            </button>
          </div>
        </Box>
      </Modal>

      <ErrorPopup
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />

      <ModalConfirmationAction
        open={openConfirmation}
        setOpen={setOpenConfirmation}
        message={data ? data.message.id : ""}
        onButtonPress={() => {
          onSuccessFunc();
          handleClose();
        }}
      />
    </div>
  );
};

export default ModalApprovalPbf;
